// extracted by mini-css-extract-plugin
export default {"container":"federation_container__l1cam","federation":"federation_federation__8vC3R","text":"federation_text__kH1Se"};